import React, { ComponentProps, memo } from 'react'

import { Box, Checkbox } from '@surglogs-app/ui'

import { useTranslation } from '../services'

export const RemindersEditorListItemAddDefaultCheckbox = memo(
  ({ onChange, ...rest }: ComponentProps<typeof Checkbox>) => {
    const { t } = useTranslation()

    return (
      <Box {...{ mt: 'md', mb: 'sm' }}>
        <Checkbox {...{ 'aria-label': 'default-reminder', onChange, ...rest }}>
          {t('addDefault')}
        </Checkbox>
      </Box>
    )
  },
)
